import { Injectable } from '@angular/core';
// Ancien import du tuto qui ne marche plus
// import * as firebase from 'firebase';
// !! Du coup ne pas oublier d'impoter les autres modules comme auth et firestore!!
import firebase from 'firebase/app';
import 'firebase/auth';
// import "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  createNewUser(email: string, password: string) {
    // Moi je dois ajouter <void> à Promise sinon erreur
    return new Promise<void>(
      (resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(email, password).then(
          () => {
            resolve()
          },
          (error) => {
            reject(error);
          }
        )
      }
    )
  }

  signInUser(email: string, password: string) {
    // Moi je dois ajouter <void> à Promise sinon erreur
    return new Promise<void>(
      (resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(email, password).then(
          () => {
            resolve()
          },
          (error) => {
            reject(error);
          }
        )
      }
    );
  }

  signOutUser() {
    firebase.auth().signOut();
  }
}
